import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Book } from "@modules/books/types";
import { BookFormValues } from "@modules/books/validations";
import requestErrorTreatment from "@shared/utils/requestErrorTreatment";
import { editBookService } from "./service";
import { UseEditBookMutationOptions } from "./types";
import { listBooksQueryKey } from "../../queries/listBooks/query";

export function useEditBookMutation(
  id: string,
  options?: UseEditBookMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();
  const queryClient = useQueryClient();

  return useMutation<Book, ApiError, Partial<BookFormValues>>({
    mutationFn: (data) => editBookService(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listBooksQueryKey,
        refetchType: "all",
      });

      open?.({
        type: "success",
        message: translate("v1/book_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      requestErrorTreatment(error, open);
    },
    ...options,
  });
}
